import zappy from "@zappy-ride/library.react.components";
import { OutputOverview } from "./Overview";

export * from "./Overview";

zappy.FactoryInstance.registerComponent(OutputOverview);
